export default __webpack_public_path__ + "media/images/open-graph-image-0e33230f24c567f018e2c62d7d0b2a67.jpg";